"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var register_component_1 = require("../register/register.component");
var RegistrationHolderComponent = /** @class */ (function () {
    function RegistrationHolderComponent(dialog) {
        this.dialog = dialog;
    }
    RegistrationHolderComponent.prototype.ngAfterViewInit = function () {
        var dialogRef = this.dialog.open(register_component_1.RegisterComponent, {
            width: "650px",
            disableClose: false,
            panelClass: "registerComponentPanel",
            height: "auto"
        });
        dialogRef.afterClosed().subscribe(function (v) {
            if (!dialogRef.componentInstance.afterRegClose) {
                window.history.back();
            }
        });
    };
    RegistrationHolderComponent.prototype.ngOnInit = function () {
    };
    return RegistrationHolderComponent;
}());
exports.RegistrationHolderComponent = RegistrationHolderComponent;
